exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".btn.btn-link {\r\n    min-width: unset;\r\n    padding: 0;\r\n    color: #3b3b3b;\r\n    font-weight: 600;\r\n    text-transform: none;\r\n    text-decoration: underline;\r\n}\r\n\r\nhtml:not([dir=\"rtl\"]) .btn.btn-link {\r\n    text-align: left;\r\n}\r\n\r\n[dir=\"rtl\"] .btn.btn-link {\r\n    text-align: right;\r\n}\r\n\r\n.form-group--password-reset {\r\n    margin-top: 0;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/styles/account/loginForm.component.css
// module id = 439
// module chunks = 0